var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHogar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hogar",
    clipPath: "url(#clip0_5969_3674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICONOS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.0783 10.3845H30.002V11.54H33.0783V10.3845Z",
    fill: "#F15B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.6928 21.6594H14.6165V24.7358H17.6928V21.6594Z",
    fill: "#F15B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.54 21.6594H8.46362V24.7358H11.54V21.6594Z",
    fill: "#F15B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20 0C8.95624 0 0 8.95624 0 20C0 31.0438 8.95624 40 20 40C31.0438 40 40 31.0438 40 20C40 8.95624 31.0475 0 20 0ZM20 1.53817C30.1951 1.53817 38.4618 9.80489 38.4618 20C38.4618 22.7429 37.8632 25.3457 36.7911 27.6871H33.082V12.3016H29.9943V14.283L26.4747 10.7634H12.0061L5.37981 17.3897V27.6871H3.21273C2.14056 25.3457 1.54196 22.7429 1.54196 20C1.53817 9.80489 9.80489 1.53817 20 1.53817ZM24.6145 21.7655V27.6871H20.7729V18.0299L26.1527 12.635L30.2216 16.7039L31.5325 18.0299V27.6871H28.7176V21.7655H24.6145ZM6.92555 18.4846H19.2233V27.6871H6.92934V18.4846H6.92555ZM19.9962 38.4618C13.1654 38.4618 7.20212 34.7528 4.00834 29.2366H35.9841C32.7903 34.7528 26.8271 38.4618 19.9962 38.4618Z",
    fill: "#F15B2B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5969_3674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHogar);
export default __webpack_public_path__ + "static/media/hogar.4ef57207f3b651fac26109ce3e13f01e.svg";
export { ForwardRef as ReactComponent };